import { createContext, useContext } from 'react'

export interface AccionDeAviso {
  etiqueta: string
  alHacer: () => void
}

export type Avisar = (
  texto: string,
  opciones?: { accion?: AccionDeAviso; duracionMs?: number },
) => void

export const AvisadorContexto = createContext<Avisar | null>(null)

/** Dispara un aviso del sistema. Requiere `<AvisadorProveedor>` arriba. */
export function useAvisar(): Avisar {
  const avisar = useContext(AvisadorContexto)
  if (!avisar) throw new Error('useAvisar necesita un <AvisadorProveedor> arriba')
  return avisar
}
